export const errorMessage = {
  server: 'خطا در ارتباط با سرور',
  notAllowed: 'شما دسترسی لازم برای انجام این کار ندارید',
  network: 'لطفا اتصال اینترنت خود را بررسی کنید',
  fail: 'مشکلی بوجود آمده.لطفا دوباره امتحان کنید',
  forbidden: 'امکان ورود شما وجود ندارد',
  dataUnvalid: 'لطفا مقادیر معتبر وارد کنید',
  notSupported: 'دستگاه شما این قابلیت روشن شدن فلش را پشتیبانی نمی کند',
  notFound: 'اطلاعات یافت نشد',
}

export const infoMessage = {
  sendUsernamePass: 'نام کاربری و رمز عبور برای شماره شما ارسال شد',
}
